import React from "react";
import {
	StyleSheet,
	TouchableOpacity
} from "react-native";

import StyledText from "./StyledText";
import Style from "ae-style";

import { useResources, useIdPrefix } from "@aetonix/hooks";

const styles = StyleSheet.create({
	toast: {
		bottom: 0,
		left: 0,
		zIndex: 1,
		backgroundColor: Style.colors.toastBackground,
		padding: 8,
		alignItems: "center"
	},
	error: {
		backgroundColor: Style.colors.red,
	}
});

export default function Toast(props){
	const { dispatch, localize } = useResources();
	const idPrefix = useIdPrefix();
	const action = dispatch("toast:trigger:hide");

	const toast = props.toast;
	const id = props.id;

	if(!toast) return (
		null
	);

	const content = localize(toast.content, toast.arguments);

	const toastStyle = toast.style || null;

	const styleList = [styles.toast];

	if(toastStyle === "error")
		styleList.push(styles.error);

	return (
		<TouchableOpacity testID={`${idPrefix}${idPrefix ? "-" : ""}${id}`} accessibilityComponentType="button" style={styleList} onPress={action}>
			<StyledText testID={id + "_text"} contrast large>{content}</StyledText>
		</TouchableOpacity>
	);
}
